<script setup lang="ts">
import { LanguagesIcon, MenuIcon } from 'lucide-vue-next'
import PMenubar from 'primevue/menubar'
const { localeMenu } = storeToRefs(useLocaleMenuStore())

const props = withDefaults(
  defineProps<{
    showPopupMenu?: boolean
  }>(),
  {
    showPopupMenu: true,
  }
)
</script>

<template>
  <PMenubar class="rounded-none fixed border-none bg-transparent">
    <template #start>
      <div class="flex items-center">
        <SideMenu
          :popup="true"
          :showUserMenu="true"
          class="lg:hidden"
          v-if="showPopupMenu"
        >
          <template #trigger="{ on }">
            <DBtn text plain v-on="on">
              <MenuIcon :size="16" />
            </DBtn>
          </template>
        </SideMenu>
        <span class="font-bold text-sm lg:pl-1">FCDF Operation</span>
      </div>
    </template>
    <template #end>
      <DMenu :items="(localeMenu as DMenuItem[])" :popup="true">
        <template #trigger="{ on }">
          <DBtn text plain v-on="on">
            <LanguagesIcon :size="16" />
          </DBtn>
        </template>
      </DMenu>
    </template>
  </PMenubar>
</template>
